import { render, staticRenderFns } from "./CollectedTable.vue?vue&type=template&id=339b6014&"
import script from "./CollectedTable.vue?vue&type=script&lang=js&"
export * from "./CollectedTable.vue?vue&type=script&lang=js&"
import style0 from "./CollectedTable.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CollectedTable.vue?vue&type=style&index=1&lang=css&"
import style2 from "./CollectedTable.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports